import SuperFetchV2 from '../../superFetchV2';
import {
  SynonymCreateRequest,
  SynonymDeleteRequest,
  SynonymDetailResponse,
  SynonymListQuery,
  SynonymListResponse,
  SynonymLogsQuery,
  SynonymLogsResponse,
  SynonymPreviewRequest,
  SynonymPreviewResponse,
  SynonymRollbackTarget,
  SynonymSaveResponse,
  SynonymUpdateRequest,
  SynonymValidateRequest,
  SynonymValidateResponse,
  UserDictionaryResponse,
  UserDictionaryValidateRequest,
  UserDictionaryValidateResponse,
} from './types';

const BASE = '/search-dictionary';
/**
 * 오류 모달을 끈다 — 이 API 의 400(errors) · 409(current) · 422(warnings) 는 화면이 줄·토큰 옆에 직접 보여 준다.
 * 전역 모달은 코드 사전에 없는 오류를 빈 창으로 띄운다.
 */
const requestOptions = { skipFullscreenLoader: true, skipErrorModal: true };
const rulePath = (ruleId: string): string => `${BASE}/synonyms/${encodeURIComponent(ruleId)}`;

export const searchDictionaryApi = {
  getSynonyms: (params: SynonymListQuery): Promise<SynonymListResponse> =>
    SuperFetchV2.get<unknown, SynonymListResponse>(`${BASE}/synonyms`, { ...requestOptions, params }),
  getSynonym: (ruleId: string): Promise<SynonymDetailResponse> =>
    SuperFetchV2.get<unknown, SynonymDetailResponse>(rulePath(ruleId), requestOptions),
  validate: (body: SynonymValidateRequest): Promise<SynonymValidateResponse> =>
    SuperFetchV2.post<unknown, SynonymValidateResponse>(`${BASE}/synonyms/validate`, body, requestOptions),
  preview: (body: SynonymPreviewRequest): Promise<SynonymPreviewResponse> =>
    SuperFetchV2.post<unknown, SynonymPreviewResponse>(`${BASE}/synonyms/preview`, body, requestOptions),
  create: (body: SynonymCreateRequest): Promise<SynonymSaveResponse> =>
    SuperFetchV2.post<unknown, SynonymSaveResponse>(`${BASE}/synonyms`, body, requestOptions),
  update: (ruleId: string, body: SynonymUpdateRequest): Promise<SynonymSaveResponse> =>
    SuperFetchV2.put<unknown, SynonymSaveResponse>(rulePath(ruleId), body, requestOptions),
  remove: (ruleId: string, body: SynonymDeleteRequest): Promise<SynonymSaveResponse> =>
    SuperFetchV2.delete<unknown, SynonymSaveResponse>(rulePath(ruleId), { ...requestOptions, data: body }),
  getLogs: (params: SynonymLogsQuery = {}): Promise<SynonymLogsResponse> =>
    SuperFetchV2.get<unknown, SynonymLogsResponse>(`${BASE}/history`, { ...requestOptions, params }),
  rollback: (logId: string, to: SynonymRollbackTarget): Promise<SynonymSaveResponse> =>
    SuperFetchV2.post<unknown, SynonymSaveResponse>(
      `${BASE}/history/${encodeURIComponent(logId)}/rollback`,
      { to },
      requestOptions,
    ),
  getUserDictionary: (): Promise<UserDictionaryResponse> =>
    SuperFetchV2.get<unknown, UserDictionaryResponse>(`${BASE}/user-dictionary`, requestOptions),
  validateUserDictionary: (body: UserDictionaryValidateRequest): Promise<UserDictionaryValidateResponse> =>
    SuperFetchV2.post<unknown, UserDictionaryValidateResponse>(
      `${BASE}/user-dictionary/validate`,
      body,
      requestOptions,
    ),
};
